import { AutoMatchingStatus } from 'redux/schemas/app/mentoring-programs';
import { ActionItemOwner, ActionItemStatus } from 'redux/schemas/models/mentoring-program-action-items';
import { User } from 'redux/schemas/models/my-account';
import { AppDispatch } from 'redux/store';

export enum EventType {
  // Mentoring program channel events
  AUTO_MATCHING = 'auto_matching',
  BULK_ENROLLMENT = 'bulk_enrollment',
  PROGRAM_CLONING_COMPLETED = 'program_cloning_completed',
  PROGRAM_CLONING_FAILED = 'program_cloning_failed',
  // Action items channel events
  NEW_ACTION_ITEM = 'new_action_item',
  UPDATE_ACTION_ITEM = 'update_action_item',
  REMOVE_ACTION_ITEM = 'remove_action_item',
}

type MentorshipProgramEvent = {
  mentorshipProgramId: number;
};

// Mentoring program event types
export type AutoMatchingEvent = MentorshipProgramEvent & {
  totalConnectionsCount: number;
  createdConnectionsCount: number;
  unmatchedCount?: number;
  autoMatchingStatus: AutoMatchingStatus;
  autoMatchingLastUpdated?: Date;
};

export type BulkEnrollmentEvent = MentorshipProgramEvent & {
  newEnrolledCount: number;
  existingEnrolledCount: number;
  errors?: [];
};

// Program cloning event types
export type ProgramCloningEvent = {
  sourceProgramId: number;
  targetProgramId: number;
  targetProgramName: string;
  clonedByUserId: number;
  timestamp: string;
};

// Action items event types
export type ActionItemEvent = {
  actionItemId: number;
  ownerClass?: ActionItemOwner;
  ownerId?: number;
  description?: string;
  status?: ActionItemStatus;
  assignedTo?: User;
  completedAt?: string;
  completedBy?: User;
};

export type Event = AutoMatchingEvent | BulkEnrollmentEvent | ProgramCloningEvent | ActionItemEvent;

type EventItem = {
  name: EventType;
  handler: (event: Event, dispatch: AppDispatch) => void;
};

export type EventList = EventItem[];
